import React from 'react'
import '../../styles.css'


export const Footer = () => {
    return (
        <div className="footer">
            <div className='footer-container'>
                
            </div>
            <div className='footer-container-bottom'>
                <div className='ps4'></div>
                <div className='naughty'></div>
            </div>
        </div>
    )
}
